import React, { Component } from 'react'
import LogoLittleShooting from './common/Logo-LittleShooting'
import _ from 'lodash'
import utils from '../utils'
import {addShoppingCart,
		canAddToShoppingCart } from '../functions/shopping-cart'
import 'react-day-picker/lib/style.css'

class Home extends Component {
	constructor(props) {
		super(props)
		this.headerAnimation = React.createRef()
	}
	componentDidMount() {
		// Pour la configuration de l'animation de la Home => voir hover.js et sur https://tympanus.net/Development/DistortionHoverEffect/
		setTimeout(() => {
			var el = this.headerAnimation.current
			new  window.hoverEffect({
				parent: el
			})
		})

		// Slider des Témoignages
		// var testimonialsInterval = 0
		// var testimonials = document.querySelectorAll('.slider__nav')
		// //testimonials[0].setAttribute("checked","checked")
		// setInterval(() => {
		// 	console.log("TESTIMONIAL = " + (testimonialsInterval))
  //           _.forEach(testimonials, (testimonial, index) => {
  //           	           // console.log("INDEX = " + index)

  //           	if(index === testimonialsInterval) {
  //           		//console.log("AA")
  //                   testimonial.setAttribute("checked", "checked")
  //               }
  //               else {
  //               	//console.log("BB")
  //                   testimonial.removeAttribute("checked", "checked")
  //               }

  //           })
            	
  //           if(testimonialsInterval === 2)
  //           	testimonialsInterval = 0
  //           else
  //           	testimonialsInterval++
  //       }, 4000)
	}
	goToShop() {
		document.getElementById('delivery-date').focus()
	}
	render() {
		return (
			<main id="home" role="main" className="flex-item-noshrink">
				<section className="bgc--pastel4 tiny-plm tiny-prm pll prl tiny-ptxl ptul of-hidden">
					<div className="mw1140p flex-container mauto pos-r tiny-pls tiny-prs tiny-ptl small-pls small-prs small-pt0 medium-ptm pll prl ptxl">
						<div className="pos-a posa-left w100 zi1">
							<h1 className="extra-tiny-w90 tiny-w70 small-w70 w40 tiny-pts small-pt0 ptl medium-pll large-pll extra-large-pll extra-tiny-center tiny-center small-center">
								<LogoLittleShooting className="logo-littleshooting"/>
								<span className="visually-hidden">Little Shooting</span>
							</h1>
						</div>
						<div ref={this.headerAnimation} className="grid__item-content">
							<div className="grid__item">
								<h2 className="grid__item-title u-secondary-bold extra-tiny-txtcenter tiny-txtcenter small-txtcenter">Vos photos produits au meilleur&nbsp;prix</h2>
								<img className="grid__item-img" src="/assets/images/basket.png" alt="Image"/>
							</div>
							<div className="grid__item is-hidden">
								<h2 className="grid__item-title u-secondary-bold extra-tiny-txtcenter tiny-txtcenter small-txtcenter">Des packshots de qualité sous 72&nbsp;heures</h2>
								<img className="grid__item-img" src="/assets/images/sac.png" alt="Image"/>
							</div>
							<div className="grid__item is-hidden">
								<h2 className="grid__item-title u-secondary-bold extra-tiny-txtcenter tiny-txtcenter small-txtcenter">Plébiscité par les grandes marques</h2>
								<img className="grid__item-img" src="/assets/images/sweat.png" alt="Image"/>
							</div>
							<div className="grid__item is-hidden">
								<h2 className="grid__item-title u-secondary-bold extra-tiny-txtcenter tiny-txtcenter small-txtcenter">Optimisé pour les principales marketplaces</h2>
								<img className="grid__item-img" src="/assets/images/teeshirt.png" alt="Image"/>
							</div>
						</div>
					</div>
				</section>
				<section className="mw1140p mauto txtcenter ptl pbl tiny-plm tiny-prm pll prl">
					<h2 className="tiny-pbm ptl pbl">Témoignages</h2>
					{/*<div ref={this.testimonialSlider} className="slider pos-r h350p medium-w80 large-w60 xlarge-w60 d-flex flex-nowrap flex-center flex-align-end mauto of-hidden">
						<input className="slider__nav pos-r inbl w10p h10p mas circle zi1" type="radio" name="slider" title="Témoignage L'Exception"/>
						<input className="slider__nav pos-r inbl w10p h10p mas circle zi1" type="radio" name="slider" title="Témoignage Digital Marketing"/>
						<input className="slider__nav pos-r inbl w10p h10p mas circle zi1" type="radio" name="slider" title="Témoignage Gutenberg"/>
						<div className="slider__inner d-flex flex-nowrap pos-a posa-top posa-left">
							<div className="slider__contents h100 flex-column flex-nowrap flex-center flex-align-center txtcenter">
								<p className="u-italic u-big mbl pbl">"Très satisfait de Little Shooting, le service répond aux besoins spécifiques du retail. C'est simple, rapide, les images sont qualitatives et les tarifs très&nbsp;compétitifs."</p>
								<p className="u-secondary-bold mbl pbm">Maeva Bessis<br /> L'Exception - Directrice Générale Adjointe</p>
						    </div>
						    <div className="slider__contents h100 flex-column flex-nowrap flex-center flex-align-center txtcenter">
								<p className="u-italic u-big mbl pbl">"Réactivité et flexibilité, le tout avec le sourire, c’est la promesse tenue par Little&nbsp;Shooting."</p>
								<p className="u-secondary-bold mbl pbm">Mathilde Vivier<br /> Digital Marketing Project Manager</p>
						    </div>
						    <div className="slider__contents h100 flex-column flex-nowrap flex-center flex-align-center txtcenter">
								<p className="u-italic u-big mbl pbl">"Gutenberg est partenaire de Little Shooting via ses studios parisiens. Les campagnes annonceur sont shootées et post-prodées via la plateforme Grand Shooting dans un modèle short-track garantissant une mise à disposition des images sous 72&nbsp;heures."</p>
								<p className="u-secondary-bold mbl pbm">Vincent Papin<br /> Gutenberg - Directeur Général Adjoint</p>
						    </div>
						</div>
					</div>*/}
					<div className="pos-r h350p d-flex flex-nowrap flex-center flex-align-end mauto">
						<span id="sl_play">&nbsp;</span>
						<span id="sl_pause">&nbsp;</span>
						<span id="sl_i1">&nbsp;</span>
						<span id="sl_i2">&nbsp;</span>
						<span id="sl_i3">&nbsp;</span>

						<div id="slideshow">
							<div className="play_commands">
								<a className="pause" href="#sl_pause" title="Pause"><span>Pause</span></a>
								<a className="play" href="#sl_play" title="Play"><span>Play</span></a>
							</div>
							
							<div className="container">
								<div className="c_slider">
									<div className="c_slider__contents h100 flex-column flex-nowrap flex-top flex-align-center txtcenter extra-tiny-pt0 small-pt0 tiny-pl0 ptl pls prs">
										<p className="u-italic u-big mbl pbm">"Très satisfait de Little Shooting, le service répond aux besoins spécifiques du retail. C'est simple, rapide, les images sont qualitatives et les tarifs très&nbsp;compétitifs."</p>
										<p className="u-secondary-bold mbl pbm">Maeva Bessis<br /> L'Exception - Directrice Générale Adjointe</p>
								    </div>
								    <div className="c_slider__contents h100 flex-column flex-nowrap flex-top flex-align-center txtcenter extra-tiny-pt0 small-pt0 tiny-pl0 ptl pls prs">
										<p className="u-italic u-big mbl pbm">"Réactivité et flexibilité, le tout avec le sourire, c’est la promesse tenue par Little&nbsp;Shooting."</p>
										<p className="u-secondary-bold mbl pbm">Mathilde Vivier<br /> Digital Marketing Project Manager</p>
								    </div>
								    <div className="c_slider__contents h100 flex-column flex-nowrap flex-top flex-align-center txtcenter extra-tiny-pt0 small-pt0 tiny-pl0 tiny-pr0 ptl pls prs">
										<p className="u-italic u-big tiny-mb0 mbl pbm">"Gutenberg est partenaire de Little Shooting via ses studios parisiens. Les campagnes annonceur sont shootées et post-prodées via la plateforme Grand Shooting dans un modèle short-track garantissant une mise à disposition des images sous 72&nbsp;heures."</p>
										<p className="u-secondary-bold mbl pbm">Vincent Papin<br /> Gutenberg - Directeur Général Adjoint</p>
								    </div>
								</div>
								<div className="slider">
									<div className="slider__contents h100 flex-column flex-nowrap flex-top flex-align-center txtcenter extra-tiny-pt0 small-pt0 tiny-pl0 ptl pls prs">
										<p className="u-italic u-big mbl pbm">"Très satisfait de Little Shooting, le service répond aux besoins spécifiques du retail. C'est simple, rapide, les images sont qualitatives et les tarifs très&nbsp;compétitifs."</p>
										<p className="u-secondary-bold mbl pbm">Maeva Bessis<br /> L'Exception - Directrice Générale Adjointe</p>
								    </div>
								    <div className="slider__contents h100 flex-column flex-nowrap flex-top flex-align-center txtcenter extra-tiny-pt0 small-pt0 tiny-pl0 ptl pls prs">
										<p className="u-italic u-big mbl pbm">"Réactivité et flexibilité, le tout avec le sourire, c’est la promesse tenue par Little&nbsp;Shooting."</p>
										<p className="u-secondary-bold mbl pbm">Mathilde Vivier<br /> Digital Marketing Project Manager</p>
								    </div>
								    <div className="slider__contents h100 flex-column flex-nowrap flex-top flex-align-center txtcenter extra-tiny-pt0 small-pt0 tiny-pl0 tiny-pr0 ptl pls prs">
										<p className="u-italic u-big tiny-mb0 mbl pbm">"Gutenberg est partenaire de Little Shooting via ses studios parisiens. Les campagnes annonceur sont shootées et post-prodées via la plateforme Grand Shooting dans un modèle short-track garantissant une mise à disposition des images sous 72&nbsp;heures."</p>
										<p className="u-secondary-bold mbl pbm">Vincent Papin<br /> Gutenberg - Directeur Général Adjoint</p>
								    </div>
								</div>
							</div>
							
							<ul className="dots_commands">
								<li><a href="#sl_i1" title="Témoignage L'Exception">Témoignage L'Exception</a></li>
								<li><a href="#sl_i2" title="Témoignage Digital Marketing">Témoignage Digital Marketing</a></li>
								<li><a href="#sl_i3" title="Témoignage Gutenberg">Témoignage Gutenberg</a></li>
							</ul>
							
						</div>
					</div>
				</section>
				<Offers offers={this.props.offers} handleShoppingCartCounterAnimation={this.props.handleShoppingCartCounterAnimation} offerTooltipId={this.props.offerTooltipId} />
			</main>
		)
	}
}

class Offers extends Component {
	
	render () {
		const { offers } = this.props

		return (
			<section id="purchase-offers" className=" bgc--inverse">
				<div className="pos-r mtm txtcenter">
					<div className="pos-r zi2 pts">
						<p className="u-secondary-bold u-biggest ma0">De 14 à 38€</p>
						<span className="u-italic zi2">Livraison : 15€ en 72h</span>
					</div>
					<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="388" height="93" viewBox="0 0 388 93" className="pos-a posa-left posa-top posa-right mlauto mrauto zi1">
						<path data-name="onglet" className="offer-price-tab" d="M107.3,0h173.4c34.2,0,62,23,62,57c0,24.2,13.8,36,45.3,36H0c31.4,0,45.3-12.3,45.3-36
	C45.3,23,73.1,0,107.3,0z"/>
					</svg>
					<div>
						{
							_.map(_.filter(offers, o => o.type == 'menu'), offer => {
								return <Offer key={offer.offer_id} offer={offer} isOfferTooltipVisible={this.props.isOfferTooltipVisible} handleOfferTooltip={this.props.handleOfferTooltip} handleShoppingCartCounterAnimation={this.props.handleShoppingCartCounterAnimation} offerTooltipId={this.props.offerTooltipId} />
							})
						}
					</div>
				</div>
				{/*{
					_.size(_.filter(offers, o => o.type == 'single')) ?
						<div className="txtcenter">
							<h3>À la carte</h3>
							<p className="u-secondary-bold u-big ma0">De 7€ à 15€</p>
							<p>C'est vous qui choisissez</p>
							<div className="ptm">
							{
								_.map(_.filter(offers, o => o.type == 'single'), offer => {
									return <Offer
										key={offer.offer_id}
										offer={offer}
									/>
								})
							}
							</div>
						</div>
					: 	false
				}*/}
			</section>
		)
	}
}

class Offer extends Component {
	min = 1
	max = 20
	state = {
		quantity: 1,
		priceHt: undefined,
		isTooltipVisible: false,
		isQuantityTooltipVisible: false,
		offerTooltipId: undefined,
		showImage: 0,
		isMobileDevice: undefined
	}
	isMobileDevice = () => {
		console.log("isIpad ? = " + navigator.userAgent.indexOf('iPad'))
		return ((typeof window.orientation !== "undefined") && (navigator.userAgent.indexOf('iPad') == -1)) || (navigator.userAgent.indexOf('IEMobile') !== -1);
	}
	componentDidMount = () => {
		document.addEventListener('shoppingcart', () => this.forceUpdate())
		console.log("isMobileDevice = ", this.isMobileDevice())
		this.setState(
			{
				isMobileDevice: this.isMobileDevice(),
				priceHt: this.getPriceHt(this.state.quantity)
			}
		)
		console.log("State Quantity = " + this.state.quantity)
	}	
	add = () => {
		addShoppingCart(this.props.offer.offer_id, parseInt(this.state.quantity))
		this.props.handleShoppingCartCounterAnimation()
	}
	changeAdd = (event) => {
		const value = this.state.quantity + 1
		const min = this.min
		const max = this.max
		
		if (isNaN(value)) {
			this.setState({quantity: value, priceHt: this.state.priceHt})
		} else if (value <= min) {
			this.setState({quantity: min, priceHt: this.getPriceHt(min)})
		} else if (value >= max) {
			this.setState({quantity: max, priceHt: this.getPriceHt(value)})
		} else {
			this.setState({quantity: value, priceHt: this.getPriceHt(value)})
		}

		if (value <= min || value >= max || isNaN(value)) {
			this.handleQuantityTooltip()
		}
	}

	changeRemove = (event) => {
		const value = this.state.quantity - 1
		const min = this.min
		const max = this.max
		
		if (isNaN(value)) {
			this.setState({quantity: value, priceHt: this.state.priceHt})
		} else if (value <= min) {
			this.setState({quantity: min, priceHt: this.getPriceHt(min)})
		} else if (value >= max) {
			this.setState({quantity: max, priceHt: this.getPriceHt(value)})
		} else {
			this.setState({quantity: value, priceHt: this.getPriceHt(value)})
		}

		if (value <= min || value >= max || isNaN(value)) {
			this.handleQuantityTooltip()
		}
	}

	changeQuantity = (event) => {
		const value = parseInt(event.target.value)
		const min = this.min // 1
		const max = this.max // 20
		
		if (isNaN(value)) {
			this.setState({quantity: value, priceHt: this.state.priceHt})
		} else if (value <= min) {
			this.setState({quantity: min, priceHt: this.getPriceHt(min)})
		} else if (value >= max) {
			this.setState({quantity: max, priceHt: this.getPriceHt(value)})
		} else {
			this.setState({quantity: value, priceHt: this.getPriceHt(value)})
		}

		if (value <= min || value >= max || isNaN(value)) {
			this.handleQuantityTooltip()
		}
	}
	getPriceHt = (quantity) => {
		return _.find(this.props.offer.price, p => p.from <= quantity && (p.to && quantity <= p.to || !p.to)).price_ht
	}
	handleQuantityTooltip() {
		clearTimeout(this.quantityTooltipTimeout)
		this.setState({isQuantityTooltipVisible: true})
		this.quantityTooltipTimeout = setTimeout(() => {this.setState({isQuantityTooltipVisible: false})}, 3000)
	}
	// getQuantity = () => {
	// 	return getShoopingCartOfferNumber(this.props.offer.offer_id)
	// }
	handleTooltip = (event) => {
		if (this.state.isTooltipVisible) {
			this.setState({isTooltipVisible: false, offerTooltipId: undefined})
			document.body.classList.remove('pos-f', 'of-hidden', 'w100'); 
		} else {
			this.setState({isTooltipVisible: true, offerTooltipId: this.props.offer.offer_id})
			document.body.classList.add('pos-f', 'of-hidden', 'w100'); // prevent body scroll on mobile when offerTooltip is visible 
		}
	}
	render = () => {
		const { offer } = this.props
		const { quantity } = this.state
		const nbImages = offer.nb_image
		let img = undefined
		let thumbs = undefined

		//const price_ht = _.find(offer.price, p => p.from <= quantity && (p.to && quantity <= p.to || !p.to)).price_ht
		const price_ht = this.state.priceHt
		const price_ttc = price_ht * 1.2
		
		let quantityTooltip = undefined
		if(this.state.isQuantityTooltipVisible) {
			quantityTooltip =	<div className="w140p pos-a mtl zi0 fade-in-down-animation">
									<div className="pos-a posa-left mts">
										<div className="icon-carret--up icon-carret--up--inverse mll"></div>
									</div>
									<div className="mtm pls prs pts pbs bgc--secondary color--inverse bdra--s box-shadow u-small">
										{quantity >= 20 ? <span className="u-small">La quantité maximale est de 20 produits</span> : <span className="u-small">La quantité minimale est de 1 produit</span>}
									</div>
								</div>
		}

		return (
				<div className={"mts" + (nbImages == 2 ? " bgc--pastel3" : nbImages == 3 ? " bgc--pastel1" : nbImages == 6 ? " bgc--pastel2" : " bgc--pastel4")}>
					<div className="offer mw1140p tiny-w100 small-w100 medium-w70 mauto tiny-plm tiny-prm small-pll small-prl medium-pll medium-prl large-pll large-prl d-flex ptl pbl txtleft of-hidden">
						<div className="tiny-w100 small-w100 medium-w100 w60 d-flex ptl pbl large-prxl extra-large-prl">
							<div className="offer-pics d-flex flex-item-fluid">
								<div className="mtauto mbauto">
									<img src={utils.getImgPath(offer.tile_image)} alt={"Vues " + offer.smalltext}/>
									{/*<img src="/assets/images/maroquinerie1.png" alt=""/>*/}
								</div>
							</div>
						</div>
						<div className="tiny-w100 small-w100 medium-w100 w40 flex-self-end large-ptl extra-large-ptl pbl">
							<div className="offer-desc tiny-pt0 ptm">
								<h3 className="u-secondary-bold pbm"><span className="u-big">{offer.smalltext}</span></h3>
								<p>{offer.description}</p>
							</div>
							<div className="u-small pts pbm">
								<div className="d-flex mas ml0 u-big">
									<span className="lnr lnr-picture u-bigger mrs"></span>
									<span className="d-flex flex-align-baseline">
										<span className="u-secondary-bold">{(offer.nb_image > 1 ? (offer.nb_image == 3 ? (offer.nb_image - 1) + ' vues' : offer.nb_image + ' vues') : offer.nb_image + ' vue')}</span>
										{offer.smalltext == "Ghost" ? <span className="u-secondary u-small pls ptt">(+ une vue détail offerte)</span> : false}
									</span>
								</div>
							</div>
							<div className="d-flex flex-nowrap bgc--inverse bdra--ul pts pbs prs pls mts">
								<div className="offer-price flex-item-fluid d-flex">
									<div className="d-flex flex-item-center">
										<p className="d-flex flex-align-baseline txt-left extra-tiny-mlt mls large-mlm mrs mb0">
											<span className="u-secondary-bold prs">{utils.printPrice(price_ht)}€&nbsp;HT</span>
											<small className="u-secondary">{utils.printPrice(price_ttc)}€&nbsp;TTC</small>
										</p>
									</div>
								</div>
								<div className="offer-quantity d-flex flex-align-baseline">
									<label className="pos-r d-flex flex-align-baseline extra-tiny-mrt mrm mb0">
										<span className="extra-tiny-hidden prs u-small">Qté</span>
										<span ref="quantity">
											<span className="pos-a posa-right posa-top posa-bottom w25p h100 zi1 bdl--t"><span className="quantity-up pos-a posa-top posa-right d-inbl w100 h50 txtcenter" onClick={this.changeAdd}>+</span><span className="quantity-down pos-a posa-bottom posa-right d-inbl w100 h50 txtcenter bdt--t" onClick={this.changeRemove}>—</span></span>
											<input className="input--tiny-plus pos-r w60p h50p ma0 no-boxshadow u-secondary txtright" ref="offer_number" type="number" name="number" pattern="[0-9]*" value={quantity} onChange={this.changeQuantity} max={this.max} min={this.min} step="1"/>
										</span>
									</label>
									{quantityTooltip}
								</div>
								<div className="offer-add flex-self-end">
									<button className="pos-r h60p btn--secondary" onClick={this.add} disabled={!canAddToShoppingCart(quantity)}>
										<span className="color--inverse tiny-pl0 tiny-pr0 prt plt">Ajouter au panier</span>
									</button>
								</div>
							</div>
							<div className="d-flex flex-space-between pts mtt plm prm"><small className="u-italic">Tarif dégressif dès 6 produits</small><small className="u-italic prs">20 produits maximum</small></div>
						</div>
					</div>
				</div>
		)
	}
}


export default Home



// WEBPACK FOOTER //
// ./src/components/Home.js